import { useQ } from '@olagg/api-hooks';
import { AdminPushNotificationEndpoints } from '@olagg/api-hooks/endpoints/adminEndpoints';
import { PushNotificationsResponse } from './types';

interface UsePushNotificationsParams {
  page: number;
  limit: number;
  title?: string;
  status?: string;
  segment_id?: number;
  user_id?: number;
  from_date?: string;
  to_date?: string;
  order_by?: string;
  order_dir?: string;
}

export const usePushNotifications = ({
  page,
  limit,
  title,
  status,
  segment_id,
  user_id,
  from_date,
  to_date,
  order_by,
  order_dir
}: UsePushNotificationsParams) => {
  const response = useQ<PushNotificationsResponse>(
    AdminPushNotificationEndpoints.all({
      page,
      limit,
      title,
      status,
      segment_id,
      user_id,
      from_date,
      to_date,
      order_by,
      order_dir
    }),
    {
      revalidateOnFocus: false,
    }
  );

  return {
    ...response,
    pushNotifications: response.data?.pushNotifications || [],
    count: response.data?.meta?.totalCount || 0,
  };
};
